import { Facebook, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#05080F]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-baseline gap-3 mb-4">
              <span className="font-mono text-xs tracking-[0.3em] text-[#E5A93B]">
                AQUA / AERIALS
              </span>
              <span className="font-mono text-xs tracking-[0.3em] text-white/40">
                LKA
              </span>
            </div>
            <h3 className="text-3xl md:text-5xl font-bold tracking-tight text-white max-w-lg">
              Shoot us a line.
              <br />
              <span className="text-[#E5A93B]">We&apos;ll fly the rest.</span>
            </h3>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/40 mb-4">Contact</div>
            <a
              href="mailto:lake.anna.aqua.aerials@gmail.com"
              data-testid="footer-email"
              className="group inline-flex items-center gap-2 text-white hover:text-[#E5A93B] transition font-mono text-xs whitespace-nowrap"
            >
              <Mail size={12} className="text-[#E5A93B] shrink-0" />
              lake.anna.aqua.aerials@gmail.com
            </a>
            <div className="mt-3 font-mono text-xs text-white/50">
              Lake Anna, Virginia
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/40 mb-4">Follow</div>
            <a
              href="https://www.facebook.com/profile.php?id=61590575197473"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-facebook"
              className="inline-flex items-center gap-2 text-white hover:text-[#E5A93B] transition font-mono text-sm"
            >
              <Facebook size={14} className="text-[#E5A93B]" />
              Facebook
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/40">
            © {new Date().getFullYear()} Aqua Aerials LKA · FAA Part 107
          </div>
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/30">
            N 38.0° W 77.7°
          </div>
        </div>
      </div>
    </footer>
  );
};
